import type { CadenceStatus, CadenceTask } from "../../api/cadence.ts";
import { periodLabel, statusLabel } from "../CadenceCalendar.helpers.ts";

type TaskListProps = {
  tasks: CadenceTask[];
  busyTaskId: number | null;
  onStatus: (taskId: number, status: CadenceStatus) => void;
  onOpenConversation: (task: CadenceTask) => void;
  onReschedule: (task: CadenceTask) => void;
  onHistory: (task: CadenceTask) => void;
  onDelete: (taskId: number) => void;
};

export function TaskList({
  tasks,
  busyTaskId,
  onStatus,
  onOpenConversation,
  onReschedule,
  onHistory,
  onDelete,
}: TaskListProps) {
  if (!tasks.length) {
    return <div className="cadence-empty">Sem leads agendados para este dia.</div>;
  }

  return (
    <div className="cadence-task-list" aria-label="Cadencias do dia">
      {tasks.map((task) => (
        <article
          key={task.id}
          className={`cadence-task status-${task.status}`}
          draggable
          onDragStart={(event) => {
            event.dataTransfer.setData("text/x-cadence-task-id", String(task.id));
            event.dataTransfer.effectAllowed = "move";
          }}
        >
          <div className="cadence-task-main">
            <strong>{task.leadName || task.leadPhone || task.leadId}</strong>
            <span>{task.leadPhone || "Sem telefone"} - {periodLabel(task.scheduledPeriod)}</span>
            {task.note ? <p>{task.note}</p> : null}
          </div>
          <div className="cadence-task-actions">
            <span className="cadence-task-status">{statusLabel(task.status)}</span>
            <button
              type="button"
              disabled={busyTaskId === task.id || task.status === "done"}
              onClick={() => onStatus(task.id, "done")}
            >
              Concluir
            </button>
            <button
              type="button"
              disabled={busyTaskId === task.id || task.status === "skipped"}
              onClick={() => onStatus(task.id, "skipped")}
            >
              Pular
            </button>
            <button type="button" disabled={busyTaskId === task.id} onClick={() => onReschedule(task)}>
              Reagendar
            </button>
            <button type="button" onClick={() => onOpenConversation(task)}>
              Abrir conversa
            </button>
            <button type="button" onClick={() => onHistory(task)}>
              Historico
            </button>
            <button type="button" disabled={busyTaskId === task.id} onClick={() => onDelete(task.id)}>
              Remover
            </button>
          </div>
        </article>
      ))}
    </div>
  );
}
